export default "__VITE_ASSET__Cfw3ivLB__"